<template>
  <div>
    <list
      row-key="testId"
      ref="list"
      unit="检验日志"
      :page="page"
      :show-query="showQuery"
      :get-data-func="api.list"
      v-if="trendShow"
      urlHash="production/reportmanagement/qualityinspection/checkLog"
      :tempParams="tempParams"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="tabs">
        <el-tabs v-model="tabName" type="card" @tab-click="tabClick">
          <el-tab-pane label="注塑质检日志" name="0"></el-tab-pane>
          <!-- <el-tab-pane label="特殊加工质检日志" name="1"></el-tab-pane>
          <el-tab-pane label="配件装配质检日志" name="2"></el-tab-pane>
          <el-tab-pane label="产品装配质检日志" name="3"></el-tab-pane>
          <el-tab-pane label="产品组合质检日志" name="4"></el-tab-pane> -->

          <el-tab-pane v-for="(item, index) in machiningStageList" :key="index" :label="item.Name + '质检日志'" :name="item.MachiningStageId + ''"></el-tab-pane>
        </el-tabs>
      </template>
      <template slot="table">
        <!-- <el-table-column prop="AddEmpName" label="提交人员" width="100" /> -->
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <details0-dialog v-if="tabName == '0'" ref="details0Dialog" />
    <details1-dialog v-else ref="details1Dialog" />
    <!-- <details2-dialog ref="details2Dialog" />
    <details3-dialog ref="details3Dialog" />
    <details4-dialog ref="details4Dialog" /> -->
  </div>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'
import details0Dialog from '@/components/production/reportmanagement/qualityinspection/checkLog/phase1/detailsDialog'
import details1Dialog from '@/components/production/reportmanagement/qualityinspection/checkLog/phase2/detailsDialog'
import details2Dialog from '@/components/production/reportmanagement/qualityinspection/checkLog/phase3/detailsDialog'
import details3Dialog from '@/components/production/reportmanagement/qualityinspection/checkLog/phase4/detailsDialog'
import details4Dialog from '@/components/production/reportmanagement/qualityinspection/checkLog/phase5/detailsDialog'

export default {
  mixins: [listMixin],
  components: {
    list,
    details0Dialog,
    details1Dialog,
    details2Dialog,
    details3Dialog,
    details4Dialog
  },
  provide() {
    return {
      IsDefaultMonth: false
    }
  },
  data() {
    return {
      api: require('@/api/pr/test').default,
      machiningStageApi: require('@/api/ba/machiningStage').default,
      trendShow: true,
      params: {
        WorkDocNo: '',
        StartDate: null,
        EndDate: null,
        Stage: 0
      },
      tabName: '0',
      Combination: [],
      Assembling: [],
      Parts: [],
      Special: [],
      Injection: [],
      tempParams: {
        Stage: 0
      },
      machiningStageList: []
    }
  },
  created() {
    this.machiningStageApi.list({ Status: 1, Universal: true }).then(res => {
      this.machiningStageList = res.Data
    })
  },
  methods: {
    // getDataEnd(resData) {
    //   console.log("getDataEnd ==== resData", resData);
    //   let Combination = [];
    //   let Assembling = [];
    //   let Parts = [];
    //   let Special = [];
    //   let Injection = [];

    //   let data = resData;
    //   let length = data.length;

    //   for (let i = 0; i < length; ++i) {
    //     let stage = data[i].Stage;
    //     switch (stage) {
    //       case 0:
    //         Injection.push(data[i]);
    //         break;
    //       case 1:
    //         Special.push(data[i]);
    //         break;
    //       case 2:
    //         Parts.push(data[i]);
    //         break;
    //       case 3:
    //         Assembling.push(data[i]);
    //         break;
    //       case 4:
    //         Combination.push(data[i]);
    //         break;
    //     }
    //   }

    //   this.Combination = Combination;
    //   this.Assembling = Assembling;
    //   this.Parts = Parts;
    //   this.Special = Special;
    //   this.Injection = Injection;

    //   if (this.tabName === "0") this.$refs.list.setTable(this.Injection);
    //   if (this.tabName === "1") this.$refs.list.setTable(this.Special);
    //   if (this.tabName === "2") this.$refs.list.setTable(this.Parts);
    //   if (this.tabName === "3") this.$refs.list.setTable(this.Assembling);
    //   if (this.tabName === "4") this.$refs.list.setTable(this.Combination);
    // },
    tabClick() {
      this.tempParams.Stage = Number(this.tabName)
      this.$refs.list.getData()
      // if (this.tabName === "0") this.$refs.list.setTable(this.Injection);
      // if (this.tabName === "1") this.$refs.list.setTable(this.Special);
      // if (this.tabName === "2") this.$refs.list.setTable(this.Parts);
      // if (this.tabName === "3") this.$refs.list.setTable(this.Assembling);
      // if (this.tabName === "4") this.$refs.list.setTable(this.Combination);
      // console.log("tab", this.tabName);
      // this.$refs.list.getData({ Stage: this.tabName });
    },
    details(id) {
      var name = 'details0Dialog'
      if (this.tabName === '0') {
         name = 'details0Dialog'
      } else {
        name="details1Dialog";
      }
      this.$refs[name].openDetailsById(id)
    }
  }
}
</script>
